import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore, useUserStore } from "../../stores";
import ModalShell from "../../components/shared/ModalShell";

function Home() {
  // Global state.
  const { isAuth } = useAuthStore();
  const { userType } = useUserStore();
  const location = useLocation();

  // Local state for modal type.
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);

  // Open modal logic.
  const onShowModal = (type) => {
    setShowModal(true);
    setModalType(type);
  };

  // Set up previously logged in navigation.
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the appropriate home page if the user is already logged in
    if (isAuth) {
      if (userType === "rider") {
        navigate("/riderhome");
      } else if (userType === "driver") {
        navigate("/driverhome");
      }
    }
  }, [isAuth, userType, navigate]);

  // Auto-open signup modal if navigated from /signup route (invite link)
  useEffect(() => {
    if (location.state?.openSignup) {
      onShowModal("signup");
    }
  }, [location.state]);

  return (
    <div className="page-component-layout justify-center py-8">
      <h3 className="text-3xl md:text-4xl font-bold text-white mb-2">
        Welcome to Arryde!
      </h3>
      <p className="text-main-light-highlight text-sm md:text-base mb-6 max-w-md">
        Not Who's Closest, Who You're Closest To
      </p>

      {/* Guest (anonymous) rides are disabled for the invite-only alpha —
          the CTA opens login instead of the (now rider-only) ride form.
          Tracked as a future feature in CLAUDE.md. */}
      <button
        className="btn btn-blue btn-round-large"
        onClick={() => onShowModal("login")}
      >
        Find A Ride
      </button>

      <p className="text-main-light-highlight/80 text-sm max-w-sm mb-6">
        Log in to request rides, save favorite drivers, and more!
      </p>

      <div className="flex flex-col gap-3 w-full max-w-xs">
        <button
          className="btn btn-blue btn-md w-full"
          onClick={() => onShowModal("login")}
        >
          Log In
        </button>
        <button
          className="btn btn-blue btn-md w-full"
          onClick={() => onShowModal("signup")}
        >
          Sign Up
        </button>
        <button
          className="btn btn-blue btn-md w-full"
          onClick={() => onShowModal("driver-login")}
        >
          Driver Log In
        </button>
      </div>

      <ModalShell
        modalType={modalType}
        showModal={showModal}
        setModalType={setModalType}
        setShowModal={setShowModal}
      />
    </div>
  );
}

export default Home;
